import { FOUNDER_TITLE_LABEL, FOUNDER_PICKER_SENTINEL } from './founderTitle';
import { QA_TITLE_LABEL, QA_TITLE_EPITHET, QA_PICKER_SENTINEL } from './qaTitle';

// How many badges a player can pin to the front of their profile. The
// pinned set is what every other surface (leaderboards) mirrors, so the
// cap lives here rather than in the profile overlay.
export const PIN_LIMIT = 3;

const FOUNDER_DESCRIPTION = 'Awarded to every closed-beta tester who walked the halls before the gates opened.';
const QA_DESCRIPTION = 'Awarded to the testers who walk the halls while they are still being built, and break what must not break.';

// Every badge a player holds, in display order: the role badges first.
// QA, then founder. With crowns after in highest-wins order. Each entry
// carries `kind` so AvatarCrownBadge can render the right emblem, and
// `id` is what pinnedBadgeIds references.
export function buildPlayerBadges({ crowns = [], isFounder = false, isQaTester = false } = {}) {
  const badges = [];
  if (isQaTester) {
    badges.push({
      id: QA_PICKER_SENTINEL,
      kind: 'qa',
      avatarId: QA_PICKER_SENTINEL,
      label: QA_TITLE_LABEL,
      title: QA_TITLE_EPITHET,
      description: QA_DESCRIPTION,
    });
  }
  if (isFounder) {
    badges.push({
      id: FOUNDER_PICKER_SENTINEL,
      kind: 'founder',
      avatarId: FOUNDER_PICKER_SENTINEL,
      label: FOUNDER_TITLE_LABEL,
      title: FOUNDER_TITLE_LABEL,
      description: FOUNDER_DESCRIPTION,
    });
  }
  for (const crown of [...crowns].sort((a, b) => (b.wins || 0) - (a.wins || 0))) {
    badges.push({ ...crown, id: crown.avatarId, kind: 'crown' });
  }
  return badges;
}

// The pinned subset shown on the profile header and on leaderboard rows.
// The player's saved order wins; anything they reference that no longer
// exists (e.g. a lapsed crown) silently drops out. When they've saved
// nothing, default to the first few badges so the strip never reads as
// empty for someone who actually holds badges.
export function resolvePinnedBadges(allBadges, pinnedBadgeIds) {
  const saved = Array.isArray(pinnedBadgeIds) ? pinnedBadgeIds : [];
  const badgeById = new Map(allBadges.map((b) => [b.id, b]));
  const pinned = saved
    .map((id) => badgeById.get(id))
    .filter(Boolean)
    .slice(0, PIN_LIMIT);
  return pinned.length > 0 ? pinned : allBadges.slice(0, PIN_LIMIT);
}
